export default __webpack_public_path__ + "img/juris.f8a1fb25.svg";